<template>
  <ul
    v-if="!isPeriodSelectionShown"
    class="dropdown-menu"
  >
    <tr-dropdown-item
      :on-item-click="filterToThisMonth"
    >
      Este mês
    </tr-dropdown-item>
    <tr-dropdown-item
      :on-item-click="openPeriodFilter"
    >
      Definir período
    </tr-dropdown-item>
  </ul>
  <tr-period-selection
    ref="periodFilterOnMonth"
    :on-hide="onPeriodSelectionHide"
    :on-show="onPeriodSelectionShow"
    :on-filter-period="onFilter"
    :range="range"
  />
</template>

<script>
import TrPeriodSelection from './TrPeriodSelection.vue';
import TrDropdownItem from './TrDropdownItem.vue';
import moment from '@transfeeradev/moment';

export default {
  name: 'TrMonthPickerDropdown',
  components: {
    TrPeriodSelection,
    TrDropdownItem,
  },
  props: {
    onFilter: {
      required: true,
      type: Function
    },
    range: {
      required: false,
      type: Object
    }
  },
  data: () => ({
    isPeriodSelectionShown: false
  }),
  methods: {
    filterToThisMonth() {
      this.onFilter(
        moment().startOf('month'),
        moment().endOf('month'));
    },
    onPeriodSelectionHide() {
      this.isPeriodSelectionShown = false;
    },
    onPeriodSelectionShow() {
      this.isPeriodSelectionShown = true;
    },
    openPeriodFilter() {
      this.$refs.periodFilterOnMonth.open();
    }
  }
};
</script>
